import styled from 'styled-components';
import { Breadcrumb, H1 } from '@terrainvest/react-components';
import { media } from 'styled-bootstrap-grid';

export const PAGE_OFFSET = 86;

export const StyledH1 = styled(H1)`
    position: fixed;
    font-weight: 500;
    line-height: 1;
    top: 115px;

    ${media.max.lg`
        position: relative;
        top: 0px;
        margin-bottom: 0px;
    `}
`;

export const StyledAccountData = styled.div`
    position: relative;

    ${Breadcrumb.Styles.StyledBreadcrumb} {
        z-index: 0;
    }

    ${media.min.lg`
        bottom: 20px;
        padding-top: 130px;

        ${Breadcrumb.Styles.StyledBreadcrumb} {
            position: fixed;
            width: 100%;
            padding: 20px 0 26px;
            top: 72px;
            margin-bottom: 0;
        }
    `}

    ${media.max.md`
        ${Breadcrumb.Styles.StyledBreadcrumb} {
            display: none;
        }
    `}
`;

export const StyledHR = styled.hr`
    width: 100%;
    background: transparent;
    background-color: transparent;
    border-color: transparent;
    color: transparent;
    opacity: 0.4;
    margin: 10px 0;
`;
